import React, { useState } from 'react';
import practiaLogo from '../../assets/experience/practia-logo.png';
import SkillsSlider from '../Skills/SkillsSlider';

const Card = ({ image = practiaLogo, title, skills, description }) => {
  const imageUrl = require(`../../assets/experience/${image}`);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const toggleModal = () => {
    setIsModalOpen(!isModalOpen);
  };

  return (
    <>
      {/* Card */}
      <div className="card" onClick={toggleModal}>
        <div
          className="card__image"
          style={{ backgroundImage: `url(${imageUrl})` }}
        >
          <div className="card__overlay">
            <h3 className="card__title">{title}</h3>
          </div>
        </div>
        <div className="card__skills">
          {skills.map((skill, index) => (
            <span key={index} className="card__skill">
              {skill.name}
            </span>
          ))}
        </div>
      </div>

      {/* Modal */}
      {isModalOpen && (
        <div className="modal" style={{
          fontSize: "1.2rem",
          zIndex: 1000
        }}>
          <div className="modal__content" style={{
            minWidth: 400,
            maxWidth: 700,
            width: "100%",
            padding: 40,
            borderRadius: 16
          }}>
            <button className="modal__close" onClick={toggleModal} style={{ fontSize: "2rem" }}>
              &times;
            </button>
            <h2 style={{ fontSize: "2rem" }}>{title}</h2>
            <div
              style={{ margin: "1.5rem 0" }}
              dangerouslySetInnerHTML={{ __html: description }}
            />
            <SkillsSlider skills={skills} />
          </div>
        </div>
      )}
    </>
  );
};

export default Card;